/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class RecommendationExclusionRuleGetResponse extends models.RecommendationExclusionRule {
    getFixupPrototypeFunction() { return RecommendationExclusionRuleGetResponse.fixupPrototype; }

    static newInstance(model: Partial<RecommendationExclusionRuleGetResponse>): RecommendationExclusionRuleGetResponse {
        let obj = Object.assign(new RecommendationExclusionRuleGetResponse(), model);
        RecommendationExclusionRuleGetResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<RecommendationExclusionRuleGetResponse>): RecommendationExclusionRuleGetResponse {
        if (!model) return null;
        return RecommendationExclusionRuleGetResponse.newInstance(<RecommendationExclusionRuleGetResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: RecommendationExclusionRuleGetResponse) {
        if (!obj) return;

        models.RecommendationExclusionRuleGetResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: RecommendationExclusionRuleGetResponse): boolean {
        if (models.RecommendationExclusionRule.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, RecommendationExclusionRuleGetResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
